import type { AxiosRequestConfig } from 'axios'

import type {
  LoggerActivationId,
  LoggerActivationInitializer,
  LoggerActivationMutator,
} from '@beaded/models'

import * as apiUtils from '.'

const url = '/logger-activation'

export const get = (id: LoggerActivationId, options: AxiosRequestConfig = {}) =>
  apiUtils.GET(`${url}/${id}`, options)

export const getAll = (options: AxiosRequestConfig = {}) =>
  apiUtils.GET(`${url}/`, options)

export const create = (
  data: LoggerActivationInitializer,
  options: AxiosRequestConfig = {},
) => apiUtils.POST(`${url}/`, data, options)

export const update = (
  id: LoggerActivationId,
  data: LoggerActivationMutator,
  options: AxiosRequestConfig = {},
) => apiUtils.PUT(`${url}/${id}`, data, options)

export const remove = (
  id: LoggerActivationId,
  options: AxiosRequestConfig = {},
) => apiUtils.DELETE(`${url}/${id}`, options)
